import React, { useRef } from 'react';
import { SystemNotification } from '@/app/components/feedback/SystemNotification';

interface Props {
  maxSize?: number;
  onFileUpload: (files: File[]) => void;
  onRemoveLogo: () => void;
  accept?: string[];
  hasLogo: boolean;
}

const DragAndDropLogoUploader: React.FC<Props> = ({ maxSize = 10, onFileUpload, onRemoveLogo, accept, hasLogo }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFiles([e.dataTransfer.files[0]]);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (e.target.files && e.target.files.length > 0) {
      handleFiles([e.target.files[0]]);
    }
  };

  const handleFiles = (files: File[]) => {
    const validFiles = files.filter((file) => {
      if (accept && accept.length > 0) {
        const fileExtension = file.name.split('.').pop()?.toLowerCase();
        if (!accept.includes(fileExtension || '')) {
          return false;
        }
      }
      return file.size <= maxSize * 1024 * 1024;
    });

    if (validFiles.length > 0) {
      onFileUpload(validFiles);
    }
    if (validFiles.length !== files.length) {
      SystemNotification.info(`Tipo de arquivo inválido ou tamanho máximo de ${maxSize}MB excedido.`);
    }
  };

  const onButtonClick = () => {
    if (inputRef.current) {
      inputRef.current.value = ''; // Limpa o valor atual do input
      inputRef.current.click();
    }
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      {hasLogo ? (
        <div className="d-flex gap-2">
          <div className="btn btn-light-primary btn-sm mb-8" onClick={onButtonClick}>
            Alterar logo
          </div>
          <div className="btn btn-light btn-sm mb-8" onClick={onRemoveLogo}>
            <i className="bi bi-trash3 p-0 m-0" />
          </div>
        </div>
      ) : (
        <div className="d-flex flex-column align-items-center justify-content-center">
          <div
            className="d-flex align-items-center justify-content-center cursor-pointer alert alert-dismissible bg-light-secondary border border-gray-400 border-dashed border-2 p-0 mb-4"
            style={{ minHeight: '100px', minWidth: '220px' }}
            onClick={onButtonClick}
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            onDragOver={handleDrag}
            onDrop={handleDrop}
          >
            <i className="bi bi-plus-lg fs-1" />
          </div>
          <div className="btn btn-primary btn-sm mb-8" onClick={onButtonClick}>
            Adicionar logo
          </div>
        </div>
      )}
      <input
        ref={inputRef}
        accept={accept ? accept.map((type) => `.${type}`).join(',') : undefined}
        style={{ display: 'none' }}
        type="file"
        onChange={handleChange}
      />
    </div>
  );
};

export default DragAndDropLogoUploader;
